import { useState } from "react";
import { ApiError } from "./api";

function ChangePasswordModal({ accountLabel, onCancel, onSave }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [nextPassword, setNextPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function handleSave() {
    if (!currentPassword || !nextPassword || !confirmPassword) {
      setError("رمز فعلی، رمز جدید و تکرار آن را وارد کنید.");
      return;
    }
    if (nextPassword.length < 6) {
      setError("رمز جدید باید حداقل ۶ کاراکتر باشد.");
      return;
    }
    if (nextPassword !== confirmPassword) {
      setError("رمز جدید و تکرار آن یکسان نیستند.");
      return;
    }
    if (nextPassword === currentPassword) {
      setError("رمز جدید باید با رمز فعلی فرق داشته باشد.");
      return;
    }
    setBusy(true);
    setError("");
    try {
      await onSave({ currentPassword, newPassword: nextPassword, confirmPassword });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "خطا در تعویض رمز عبور");
      setBusy(false);
    }
  }

  return (
    <div className="modal-bg" style={{ display: "block" }} onClick={(e) => { if (e.target === e.currentTarget && !busy) onCancel(); }}>
      <section className="modal" role="dialog" aria-modal="true">
        <h3>تعویض رمز عبور</h3>
        <p className="entity-modal-note">رمز ورود همین حساب ({accountLabel}) به پنل عوض می‌شود. نشست فعلی برقرار می‌ماند و ورود بعدی با رمز جدید است.</p>

        <div className="modal-stack">
          <label className="sr-only" htmlFor="currentPassword">رمز عبور فعلی</label>
          <input id="currentPassword" className="input" type="password" autoComplete="current-password" placeholder="رمز عبور فعلی" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} disabled={busy} autoFocus />

          <label className="sr-only" htmlFor="nextPassword">رمز عبور جدید</label>
          <input id="nextPassword" className="input" type="password" autoComplete="new-password" placeholder="رمز عبور جدید" value={nextPassword} onChange={(e) => setNextPassword(e.target.value)} disabled={busy} />

          <label className="sr-only" htmlFor="confirmPassword">تکرار رمز عبور جدید</label>
          <input id="confirmPassword" className="input" type="password" autoComplete="new-password" placeholder="تکرار رمز عبور جدید" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} disabled={busy} onKeyDown={(e) => { if (e.key === "Enter") handleSave(); }} />
        </div>

        {error && <div className="login-error">{error}</div>}

        <div className="modal-actions">
          <button className="btn" type="button" onClick={onCancel} disabled={busy}>انصراف</button>
          <button className="btn btn-primary" type="button" onClick={handleSave} disabled={busy}>
            {busy ? "در حال ذخیره…" : "ذخیره رمز جدید"}
          </button>
        </div>
      </section>
    </div>
  );
}

export default function AdminPage({ accountLabel, canManageSettings, canManageUsers, onOpenSettings, onExport, onOpenUsers, onOpenGroups, onChangePassword }) {
  const [passwordOpen, setPasswordOpen] = useState(false);

  return (
    <main className="app-shell">
      <section className="hero">
        <div className="hero-line">
          <div>
            <h1>پنل مدیریت</h1>
            <p>تنظیمات سیستم، پشتیبان‌گیری از داده‌ها و مدیریت کاربران از همین‌جا در دسترس است.</p>
          </div>
        </div>
      </section>

      <section className="groups">
        {canManageSettings && (
          <article className="person in-group">
            <div className="person-top">
              <div className="name-block">
                <div className="name">تنظیمات آستانهٔ باف</div>
                <div className="meta">تعیین می‌کند هر چند بازخورد منفی یا مثبت، یک باف محسوب شود.</div>
              </div>
            </div>
            <div className="actions">
              <button className="btn btn-primary" type="button" onClick={onOpenSettings}>⚙ باز کردن تنظیمات</button>
            </div>
          </article>
        )}

        <article className="person in-group">
          <div className="person-top">
            <div className="name-block">
              <div className="name">داده‌ها</div>
              <div className="meta">گرفتن خروجی پشتیبان از داده‌های فعلی سیستم.</div>
            </div>
          </div>
          <div className="actions">
            <button className="btn btn-soft" type="button" onClick={onExport}>خروجی داده‌ها</button>
          </div>
        </article>

        <article className="person in-group">
          <div className="person-top">
            <div className="name-block">
              <div className="name">گروه‌ها</div>
              <div className="meta">افزودن گروه جدید یا تغییر نام و حذف گروه‌ها.</div>
            </div>
          </div>
          <div className="actions">
            <button className="btn btn-primary" type="button" onClick={onOpenGroups}>👥 مدیریت گروه‌ها</button>
          </div>
        </article>

        {canManageUsers && (
          <article className="person in-group">
            <div className="person-top">
              <div className="name-block">
                <div className="name">کاربران و دسترسی‌ها</div>
                <div className="meta">افزودن کاربر، تعیین سطح دسترسی و مدیریت دسترسی گروه‌ها.</div>
              </div>
            </div>
            <div className="actions">
              <button className="btn btn-primary" type="button" onClick={onOpenUsers}>👤 مدیریت کاربران</button>
            </div>
          </article>
        )}

        <article className="person in-group">
          <div className="person-top">
            <div className="name-block">
              <div className="name">تعویض رمز عبور</div>
              <div className="meta">رمز ورود همین حساب ({accountLabel}) به پنل مدیریت.</div>
            </div>
          </div>
          <div className="actions">
            <button className="btn btn-primary" type="button" onClick={() => setPasswordOpen(true)}>🔑 تغییر رمز عبور</button>
          </div>
        </article>
      </section>

      {passwordOpen && (
        <ChangePasswordModal
          accountLabel={accountLabel}
          onCancel={() => setPasswordOpen(false)}
          onSave={async (payload) => {
            await onChangePassword(payload);
            setPasswordOpen(false);
          }}
        />
      )}
    </main>
  );
}
